// MetaLine — línea de metadatos separada por " · " (el patrón "Tienda propia · CDMX · 3 vendedores"
// de los mocks M6). Filtra items vacíos (null/undefined/false/'') para que los campos opcionales no
// dejen puntos sueltos. Texto secundario, 12px.
import { Fragment, type ReactNode } from 'react';
import { cn } from '@/lib/cn';

export interface MetaLineProps {
    items: ReactNode[];
    className?: string;
}

export function MetaLine({ items, className }: MetaLineProps) {
    const visible = items.filter(
        (i) => i !== null && i !== undefined && i !== false && i !== '',
    );
    if (visible.length === 0) return null;
    return (
        <p className={cn('text-[12px] text-muted-foreground', className)}>
            {visible.map((item, i) => (
                <Fragment key={i}>
                    {i > 0 ? <span className="px-1.5 opacity-50">·</span> : null}
                    {item}
                </Fragment>
            ))}
        </p>
    );
}
